import { withMetadata } from '../min/metadata'

import _findPhoneNumbers from '../es6/findPhoneNumbers'

export function findPhoneNumbers() {
	return withMetadata(_findPhoneNumbers, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/index.es6.exports/findPhoneNumbers.js
// module id = 647
// module chunks = 0